<template>
    
</template>
<script>
import {alipay} from '@/api/coment'
export default {   
    //props:data,
    data(){
        return{

        }
    },
    methods:{
         getQueryVariable(variable){          
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
            }
            return(false);
         },   
         toalipay(){
            let postData = {
                outTradeNo:decodeURI(this.getQueryVariable("outTradeNo")),
                subject: decodeURI(this.getQueryVariable("subject")),
                totalAmount:decodeURI(this.getQueryVariable("totalAmount")),
                body:decodeURI(this.getQueryVariable("subject")),
            };             
            alipay(postData).then((res)=>{
            const div = document.createElement('div');
                div.innerHTML = res;
                document.body.appendChild(div);
                document.forms[0].submit();  
            }).catch((err)=>{});
        }
    },
    created(){
       this.toalipay();
    }
}
</script>


// WEBPACK FOOTER //
// src/view/other/alipay_dialog.vue